import { useContext }   from 'react';
import { ModalContext } from '../context/ModalContext';

export function useModal() {
    const { activeModal, toggleModal, dismiss } = useContext(ModalContext);

    return { activeModal, toggleModal, dismiss };
}
